export default __webpack_public_path__ + "static/media/LAS0880.34I-39646_-23533_0.9aa523e8.jpg";